import { bajaPut } from "#api/Api/baja"
import { MasterDialog } from "#common/Dialog/Dialog"
import { TERMINATION } from "#constants/StatusRequest "
import useHasPermission from "#hooks/useHasPermission"
import { Alert, Box, Divider, Stack, Typography } from "@mui/material"
import { Fragment, useCallback, useMemo, useState } from "react"
import * as TEXT from "../TextBaja"
import BajaCancelDialog from "./components/BajaCancelDialog"
import DetailTermination from "./components/DetailTermination"
import { useApi } from "#hooks/useApi"
import { bajaIdGet } from "../services/api"

export default function DialogDetailBaja({
	baja,
	open,
	setOpen,
	reload,
	dialogIndex,
	setDialogIndex,
}) {
	const { hasPermissionV2 } = useHasPermission()
	const isRH = hasPermissionV2("RH")
	const [buttonsDialog, setButtonsDialog] = useState(null)
	const [buttonsDialogFinish, setButtonsDialogFinish] = useState(false)
	const [openCancel, setOpenCancel] = useState(false)

	const closeDialog = useCallback(() => {
		setButtonsDialog(null)
		setOpen(false)
		setDialogIndex(0)
	}, [setDialogIndex, setOpen])

	const buttonFinish = useMemo(() => {
		const statusId = baja?.termination_status_id
		let buttons = []

		if (
			!isRH ||
			statusId === TERMINATION.FINALIZADA ||
			statusId === TERMINATION.CANCELADA
		)
			return buttons
		if (statusId !== TERMINATION.SOLICITADA)
			buttons.push({
				label: "Cancelar Baja",
				onClick: () => setOpenCancel(true),
				color: "error",
				// disabled: open,
			})

		if (statusId === TERMINATION.VOBO_RH)
			buttons.push({
				label: "Finalizar Baja",
				onClick: () => setButtonsDialogFinish(true),
				color: "success",
			})
		return buttons
	}, [baja?.json_final_debts, baja?.termination_status_id, isRH])

	return (
		<Fragment>
			<MasterDialog
				setOpen={setOpen}
				open={open}
				title={TEXT.TITLE_DIALOG}
				buttons={[...buttonFinish, ...(buttonsDialog || [])]}
				maxWidth={"md"}
				closeDialog={closeDialog}
			>
				<DetailTermination
					baja={baja}
					reload={reload}
					isRH={isRH}
					dialogIndex={dialogIndex}
					setButtonsDialog={setButtonsDialog}
					closeDialog={closeDialog}
				></DetailTermination>
			</MasterDialog>
			<ConfirmaBaja
				{...{
					open: buttonsDialogFinish,
					setOpen: setButtonsDialogFinish,
					id: baja?.id,
					reload,
					closeDialog,
				}}
			/>
			<BajaCancelDialog {...{ baja: baja, open: openCancel, setOpen: setOpenCancel }} />
		</Fragment>
	)
}

const ConfirmaBaja = ({ open, setOpen, reload, id, closeDialog }) => {
	const params = useMemo(() => ({ id, params: { is_completed: true } }), [id])
	const { data, loading, error } = useApi(bajaIdGet, { params, autoFetch: open })
	console.log({ data, loading, error })
	const { earnings = false, debts = false, email_send = false } = data || {}
	const [disabled, setDisabled] = useState(false)
	const send = () => {
		setDisabled(true)
		const fail = () => {
			setDisabled(false)
		}
		const success = () => {
			reload()
			setOpen(false)
			closeDialog()
		}
		bajaPut(id, { termination_status: TERMINATION.FINALIZADA }, { success, fail })
	}
	return (
		<MasterDialog
			setOpen={setOpen}
			open={open}
			title={"Confirmación Baja "}
			buttons={[{ label: "confirmar", onClick: send, disabled: disabled }]}
			maxWidth={"md"}
		>
			<Box
				sx={{
					// border: "1px solid",
					borderColor: "divider",
					borderRadius: 2,
					p: { xs: 2, sm: 3 },
					// bgcolor: "background.paper",
				}}
			>
				<Stack spacing={2}>
					<Stack spacing={0.5}>
						<Typography variant="body1" color="text.secondary">
							¿Está seguro de dar de baja a este colaborador? Esta acción es definitiva.
						</Typography>
					</Stack>
					<Divider />
					<Box
						component="ul"
						sx={{ m: 0, pl: 2, color: "text.secondary", "& li": { mb: 0.75 } }}
					>
						<li>Se desactivarán los accesos a las plataformas internas.</li>
						<li>Se cancelarán los cursos del mes siguiente en adelante.</li>
						<li>Si cuenta con personal a cargo será reasignado a su jefe directo.</li>
					</Box>
					<Stack spacing={1}>
						{!earnings && (
							<Alert severity="warning" variant="outlined">
								No existen percepciones ni deducciones registradas.
							</Alert>
						)}
						{!debts && (
							<Alert severity="warning" variant="outlined">
								No se han completado los adeudos.
							</Alert>
						)}
						{!email_send && (
							<Alert severity="warning" variant="outlined">
								No se ha enviado el correo de evaluación.
							</Alert>
						)}
					</Stack>
				</Stack>
			</Box>
		</MasterDialog>
	)
}
